// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		var start = $("#arriveInput").attr("value");
		var end = $("#departureInput").attr("value");
		var firstClick = 0;
		var limitDate = $("#limitDate").attr("value").split(",");

		$("#datesCalendar").datepicker({
			minDate: start,
			numberOfMonths: 2,
			dateFormat: "mm/dd/yy",
			maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
			beforeShowDay: function (date) {
				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate("mm/dd/yy", start);
				var endDate = $.datepicker.parseDate("mm/dd/yy", end);
	
				if (date.getTime() == startDate.getTime()) {
					return [true, "start-day"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "end-day"];
					} else {
						if (
							date.getTime() > startDate.getTime() &&
							date.getTime() < endDate.getTime()
						) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var selectedDate = $.datepicker.parseDate(
					$.datepicker._defaults.dateFormat,
					date
				);
	
				if (firstClick == 0) {
					start = date;
					end = date;
					firstClick = 1;
				} else {
					if (selectedDate <= start) {
						end = start;
						start = date;
					} else {
						end = date;
					}
					firstClick = 0;
				}
				let arrayStartDate = start.split('/');
				let startDay = `${arrayStartDate[2]}-${arrayStartDate[0]}-${arrayStartDate[1]}`
				let arrayEndtDate = end.split('/');
				let endDay = `${arrayEndtDate[2]}-${arrayEndtDate[0]}-${arrayEndtDate[1]}`
	
				$("#arriveInput").attr("value", startDay);
				$("#departureInput").attr("value", endDay);
				$("#pickup").val(start + "   -   " + end);
			},
			onChangeMonthYear: function () {
				setTimeout(function () {
					calendarH();
				}, 80);
			},
		});


		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


		let jBooking = document.querySelector(".js-booking");
		if (jBooking != undefined) {
			jBooking.addEventListener("click", function (e) {
				e.preventDefault();
				document.querySelector(".booking-block").classList.add("open");
			});
		}

		document.querySelector(".js-close").addEventListener("click", function (e) {
			e.preventDefault();
			document.querySelector(".booking-block").classList.remove("open");
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};


	let BurgerMenu = document.getElementById('js_btn_menu');
	let NavigationBox = document.getElementById('navigationBox');
	let Body = document.body;
	let Header = document.getElementById('header');

	if(BurgerMenu){
		BurgerMenu.addEventListener('click', function(e){
			e.preventDefault();
			if(this.classList.contains("open")){
				this.classList.remove('open');
				NavigationBox.classList.remove('open');
				Body.classList.remove('scroll-no');
				Header.classList.remove('open');
				 // Header.classList.add('header-scroll');
				document.querySelectorAll('#logoHeader')[0].classList.remove('hidden');
				document.querySelectorAll('#headerRight')[0].classList.remove('hidden');

				if(document.querySelectorAll('#default')[0] != null){
					document.querySelectorAll('#default')[0].classList.remove('overflow-hidden');
				}
				if(document.querySelectorAll('#home')[0] != null){
					document.querySelectorAll('#home')[0].classList.remove('overflow-hidden');
				}
			} else {
				this.classList.add('open');
				NavigationBox.classList.add('open');
				Body.classList.add('scroll-no');
				Header.classList.add('open');
				// Header.classList.remove('header-scroll');
				document.querySelectorAll('#logoHeader')[0].classList.add('hidden');
				document.querySelectorAll('#headerRight')[0].classList.add('hidden');
				window.scrollTo(0, 0);
				
				if(document.querySelectorAll('#default')[0] != null){
					document.querySelectorAll('#default')[0].classList.add('overflow-hidden');
				}
				if(document.querySelectorAll('#home')[0] != null){
					document.querySelectorAll('#home')[0].classList.add('overflow-hidden');
				}

			}
		});
	}

	$( "#booking-trigger" ).click(function() {
		if ($(".booking__container").hasClass("open-booking-container")) {
			$(".booking__container").removeClass("open-booking-container");
			$(".booking__container").addClass("close-booking-container");
		}
		else{
			$(".booking__container").addClass("open-booking-container");
			$(".booking__container").removeClass("close-booking-container");
		}
		if ($("#header").hasClass("open-booking")) {
			$("#header").removeClass("open-booking");
			$("#header").addClass("close-booking");
		}
		 else{
			$("#header").addClass("open-booking");
			$("#header").removeClass("close-booking");
		}
	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}